import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ModalType } from '../../core/enums/Modals'

interface ModalState {
	activeModal: ModalType | null
	modalProps?: any
}

const initialState: ModalState = {
	activeModal: null,
	modalProps: {
		isVisible:false
	},
}


export const closeModalWithDelay = createAsyncThunk('modal/closeWithDelay', async (_, { dispatch }) => {
	dispatch(setModalVisibility(false)) 
	setTimeout(() => {
		dispatch(closeModal()) 
	}, 300) 
})

export const openModalWithDelay = createAsyncThunk('modal/closeWithDelay', async (payload:{ modalType: ModalType; modalProps?: any }, { dispatch }) => {
	
	dispatch(openModal(payload))

	setTimeout(() => {
		dispatch(setModalVisibility(true)) 
	}, 10) 
})


const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		openModal: (state, action: PayloadAction<{ modalType: ModalType; modalProps?: any }>) => {
			state.activeModal = action.payload.modalType
			state.modalProps = action.payload.modalProps || {}
		},

		setModalVisibility: (state, action: PayloadAction<boolean>) => {
				state.modalProps.isVisible = action.payload

		},
		
		closeModal: (state) => {
			state.activeModal = null
			state.modalProps = {}
		},
	},
})

export const { openModal, closeModal , setModalVisibility} = modalSlice.actions

export default modalSlice.reducer
